<template>
    <div>
        <div class="formgrid grid p-fluid mb-2">
            <div class="field col-2 md:col-2">
                <label>Período inicial</label>
                <Calendar
                    v-model="periodoInicial"
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :manualInput="false"
                    :showButtonBar="true"
                    :maxDate="periodoFinal"
                />
            </div>
            <div class="field col-2 md:col-2">
                <label>Período final</label>
                <Calendar
                    v-model="periodoFinal"
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :manualInput="false"
                    :showButtonBar="true"
                    :minDate="periodoInicial"
                />
            </div>
            <div class="field col-4 md:col-4">
                <label>Cliente</label>
                <Dropdown
                    v-model="compradorCpf"
                    :options="compradoresParaDropdown"
                    filter
                    class="outline-none"
                    optionLabel="nome"
                    optionValue="cpf"
                    placeholder="Selecione"
                    showClear
                    dataKey="cpf"
                />
            </div>
            <div class="field col-4 md:col-4">
                <label>Evento</label>
                <div>
                    <Dropdown
                        v-model="evento"
                        :options="eventos"
                        filter
                        class="outline-none"
                        optionLabel="titulo"
                        optionValue="produtoId"
                        placeholder="Selecione"
                        showClear
                        dataKey="produtoId"
                    />
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Unidade Operacional:</label>
                    <Dropdown optionLabel="nome" v-model="unidOperacSelecionada" filter :options="unidadesOperacionais" optionValue="codUnidade"></Dropdown>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Projeto:</label>
                    <Dropdown
                        :disabled="!unidOperacSelecionada"
                        optionLabel="nome"
                        v-model="projetoSelecionado"
                        filter
                        :options="projetos"
                        optionValue="codProjeto"
                    ></Dropdown>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <div class="flex flex-column">
                    <label class="mb-2">Ação:</label>
                    <Dropdown :disabled="desabilitarAcao" optionLabel="nome" v-model="acaoSelecionada" filter :options="acoes" optionValue="codAcao"></Dropdown>
                </div>
            </div>
        </div>
        <div class="flex flex-column md:flex-row justify-content-between">
            <div>
                <Button label="Pesquisar" icon="pi pi-search" @click="pesquisar()" :disabled="!isDatasCorretas" />
                <Button label="Limpar" icon="pi pi-refresh" @click="limpar()" class="ml-2 p-button-secondary" />
            </div>
        </div>
    </div>
</template>

<script>
import Service from './service';
export default {
    components: {},

    emits: ['pesquisar', 'limpar'],

    data() {
        return {
            periodoFinal: null,
            periodoInicial: null,
            compradorCpf: null,
            compradoresParaDropdown: [],
            evento: null,
            isDatasCorretas: true,
            eventos: [],
            projetos: [],
            acoes: [],
            unidadesOperacionais: [],
            projetoSelecionado: null,
            acaoSelecionada: null,
            unidOperacSelecionada: null,
        };
    },

    methods: {
        aplicarPeriodoHoje() {
            const hoje = this.$moment().toDate();
            this.periodoInicial = hoje;
            this.periodoFinal = hoje;
        },
        montarFiltros() {
            return {
                periodoInicial: this.periodoInicial ? this.$moment(this.periodoInicial).format('YYYY-MM-DD') : null,
                periodoFinal: this.periodoFinal ? this.$moment(this.periodoFinal).format('YYYY-MM-DD') : null,
                compradorCpf: this.compradorCpf,
                eventoId: this.evento,
                projetoId: this.projetoSelecionado,
                acaoId: this.acaoSelecionada,
                unidadeOperacionalId: this.unidOperacSelecionada,
            };
        },
        pesquisar() {
            const filtros = this.montarFiltros();
            this.$emit('pesquisar', filtros);
        },

        validarPeriodo() {
            if (!this.periodoInicial || !this.periodoFinal) {
                this.isDatasCorretas = true;
                return;
            }
            this.isDatasCorretas = this.periodoInicial <= this.periodoFinal;
        },
        obterCompradores() {
            this.$store.dispatch('addRequest');
            Service.obterCompradores().then((response) => {
                if (response && response.success) {
                    this.compradoresParaDropdown = response.data;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        obterEventos() {
            this.$store.dispatch('addRequest');
            Service.obterEventos().then((response) => {
                if (response && response.success) {
                    this.eventos = response.data;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        limpar() {
            this.aplicarPeriodoHoje();
            this.compradorCpf = null;
            this.evento = null;
            this.projetoSelecionado = null;
            this.acaoSelecionada = null;
            this.unidOperacSelecionada = null;
            this.$emit('limpar', this.montarFiltros());
        },
        obterProjetos() {
            this.$store.dispatch('addRequest');
            Service.obterProjetos(this.unidOperacSelecionada)
                .then((response) => {
                    this.projetos = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Projetos', detail: 'Erro ao obter Projetos', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterAcoes() {
            this.$store.dispatch('addRequest');
            Service.obterAcoes(this.projetoSelecionado, this.unidOperacSelecionada)
                .then((response) => {
                    this.acoes = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Ações', detail: 'Erro ao obter Ações', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterUnidadesOperacionais() {
            this.$store.dispatch('addRequest');
            Service.obterUnidadesOperacionais()
                .then((response) => {
                    this.unidadesOperacionais = response.data;
                })
                .catch((error) => {
                    this.error = error;
                    this.$toast.add({ severity: 'error', summary: 'Unidades Operacionais', detail: 'Erro ao obter Unidades Operacionais', life: 3000 });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },
    },

    watch: {
        periodoInicial() {
            if (!this.periodoFinal) {
                this.isDatasCorretas = true;
                return;
            }
            this.validarPeriodo();
        },
        periodoFinal() {
            if (!this.periodoInicial) {
                this.isDatasCorretas = true;
                return;
            }
            this.validarPeriodo();
        },
        projetoSelecionado() {
            if (this.projetoSelecionado && this.unidOperacSelecionada) this.obterAcoes();
        },
        unidOperacSelecionada() {
            if (this.unidOperacSelecionada) this.obterProjetos();
        },
    },
    mounted() {
        this.aplicarPeriodoHoje();
        this.obterCompradores();
        this.obterEventos();
        this.obterUnidadesOperacionais();
    },
    computed: {
        desabilitarAcao() {
            return !(this.projetoSelecionado && this.unidOperacSelecionada);
        },
        desabilitarProjeto() {
            return !this.unidOperacSelecionada;
        },
    },
};
</script>
<style scoped>
input {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

textarea {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    resize: vertical;
}
</style>
